<template>
  <a-menu mode="horizontal" :selected-keys="[current]">
    <a-menu-item v-for="item in nav"  :key="item.route">
      <a :href="routeUri(item.route, { username: username })">
        <a-icon :type="item.icon"/>
        {{ item.text }}
      </a>
    </a-menu-item>
  </a-menu>
</template>

<script>
const nav = [
  {
    route: 'hyperion.user.edit',
    icon: 'edit',
    text: 'Edit'
  }
]
export default {
  name: "user-nav",
  props: {
    current: {
      type: String,
      required: true
    },
    username: {
      type: String,
      required: true
    }
  },
  data: () => ({
    nav
  })
}
</script>
